import moment from "moment-timezone";

// Create a function to convert UTC time to the system time zone
const convertUtcToSelectedTimeZone = (utcTimeString) => {
    return moment.utc(utcTimeString).toDate();
};

export default convertUtcToSelectedTimeZone;
